import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../../../assets/jss/components/tableStyle";
import {
  changePageTitle,
  notifyShowErrorMessage,
  notifyShowSuccessMessage,
} from "../../../common/actions/CommonActions";
import { LOCALE } from "../../../properties/Locale";
import { VacancyAppRepository } from "../VacancyAppRepository";
import BasicInfo from "../vacancyBasicInfo/BasicInfo";
import {
  Paper,
  Grid,
  Typography,
  TextField,
  Button,
  Icon,
  Table,
  TableRow,
  IconButton,
  TableCell,
  TableBody,
  TableHead,
} from "@material-ui/core";
import { Alert, AlertTitle } from "@material-ui/lab";
import FileIcon, { defaultStyles } from "react-file-icon";
import filesize from "filesize";
import { SchoolGradingRepository } from "./SchoolGradingRepository";
import { SETTINGS } from "../../../properties/ApiProps";
import { DropzoneArea, DropzoneDialog } from "material-ui-dropzone";
import { validateSchoolGrading } from "./SchoolGradingValidator";
import { Redirect } from "react-router-dom";
import { AuthService } from "../../../auth/AuthService";

const useStyles = makeStyles(styles);

export default function SchoolGradingComponent(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [btnSubmitLoading, setBtnSubmitLoading] = useState(false);
  const [rerender, triggerRerender] = React.useState(false);
  const [formDataErrors, setFormDataErrors] = useState();
  const [formData, setFormData] = useState({ points: 0, attachments: [] });
  const [vacancyApplication, setVacancyApplication] = useState();
  const { vacancyApplicationId } = props.match.params;
  const [attachments, setAttachments] = useState([]);
  const [files, setFiles] = useState([]);
  const [openUploadDialog, setOpenUploadDialog] = useState(false);
  const [redirect, setRedirect] = useState("");

  const handleSubmit = () => {
    var validFormData = validateSchoolGrading.isValidSync(formData);
    if (validFormData) {
      SchoolGradingRepository.saveSchoolGrading(vacancyApplication.id, formData)
        .then((res) => {
          dispatch(notifyShowSuccessMessage(LOCALE.evaluation_submited));
          setRedirect("/app/grading/school/");
        })
        .catch((err) => {});
    } else {
      var validationErrors = {};
      validateSchoolGrading
        .validate(formData, { abortEarly: false })
        .catch((err) => {
          err.inner.forEach((validationError) => {
            validationErrors[validationError.path] = {};
            validationErrors[validationError.path].message =
              validationError.message;
          });
          setFormDataErrors(validationErrors);
        });
    }
  };

  useEffect(() => {
    dispatch(changePageTitle(LOCALE.school_grading));
    if (vacancyApplicationId) {
      VacancyAppRepository.get(vacancyApplicationId).then((res) => {
        setVacancyApplication(res.data);
        SchoolGradingRepository.getSchoolGrading(vacancyApplicationId).then(
          (response) => {
            if (response.data.points === null) response.data.points = 0;
            setFormData(response.data);
          }
        );
      });
    }
  }, []);

  const setFormDataProp = (event, name) => {
    var data = formData;
    data[name] = event.target.value;
    setFormData(data);
    triggerRerender(!rerender);
  };

  const deleteFile = (id, index) => {
    let data = formData.attachments;
    SchoolGradingRepository.deleteFile(vacancyApplicationId, id).then((res) => {
      SchoolGradingRepository.getSchoolGrading(vacancyApplicationId).then(
        (response) => {
          let tmpFormData = formData;
          tmpFormData.attachments = response.data.attachments;
          setFormData(tmpFormData);
          triggerRerender(!rerender);
        }
      );
    });
  };

  const handleChangeFile = (files) => {
    setFiles(files);
    SchoolGradingRepository.uploadFile(
      vacancyApplicationId,
      files[files.length - 1]
    ).then(
      (res) => {
        SchoolGradingRepository.getSchoolGrading(vacancyApplicationId).then(
          (response) => {
            let tmpFormData = formData;
            tmpFormData.attachments = response.data.attachments;
            setFormData(tmpFormData);
            setOpenUploadDialog(false);
          }
        );
      },
      (err) => {}
    );
  };

  if (redirect) {
    return <Redirect to={redirect} />;
  }
  return (
    <Paper>
      <Grid container spacing={3}>
        <Grid item xs={2}></Grid>
        <Grid item xs={8}>
          <Typography variant="h6" style={{ textAlign: "center" }}>
            {LOCALE.basic_info}
          </Typography>
          <BasicInfo vacancyAppId={vacancyApplicationId} disabled={true} />
          <br />
          <br />
        </Grid>
        <Grid item xs={2}></Grid>
        <Grid item xs={2}></Grid>
        <Grid item xs={8}>
          <Typography variant="h6" style={{ textAlign: "center" }}>
            {LOCALE.grading}
          </Typography>
          <br />
          <Alert fullwidth="true" severity={"info"}>
            <AlertTitle>{LOCALE.school_grading_info_box_title}</AlertTitle>
            {LOCALE.school_grading_info_box_description}
          </Alert>
          <br />
          {formDataErrors && (
            <Alert fullwidth="true" severity={"error"}>
              <AlertTitle>{LOCALE.invalid_data_entry}</AlertTitle>
              <ul>
                {formDataErrors.points && (
                  <li> {formDataErrors.points.message}</li>
                )}

                {formDataErrors.attachments && (
                  <li>{formDataErrors.attachments.message}</li>
                )}
              </ul>
            </Alert>
          )}
          <br />
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <TextField
                id="comment"
                label={LOCALE.comment}
                fullWidth={true}
                InputLabelProps={{ shrink: true }}
                margin="normal"
                variant="outlined"
                multiline={true}
                rows={4}
                size="small"
                name="comment"
                onChange={(e) => setFormDataProp(e, "comment")}
                value={formData?.comment}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                id="points"
                label={LOCALE.points}
                fullWidth={true}
                InputLabelProps={{ shrink: true }}
                margin="normal"
                variant="outlined"
                size="small"
                name="points"
                onChange={(e) => setFormDataProp(e, "points")}
                value={formData?.points}
                error={formDataErrors?.points}
                helperText={formDataErrors?.points?.message}
              />
            </Grid>
            <Grid item xs={3}>
              <Button
                variant="contained"
                color="primary"
                error={formDataErrors?.attachments}
                helperText={formDataErrors?.attachments?.message}
                style={{ marginTop: "16px", marginLeft: "5px" }}
                onClick={() => setOpenUploadDialog(true)}
              >
                <Icon>attach_file</Icon> &nbsp; {LOCALE.uploadFile}
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <br />
        <Grid item xs={2}></Grid>
        <Grid item xs={2}></Grid>
        <Grid container xs={8}>
          <Grid item xs={12}>
            <DropzoneDialog
              multiple={false}
              onChange={(files) => handleChangeFile(files)}
              previewChipProps={false}
              showFileNamesInPreview={false}
              showPreviews={false}
              showPreviewsInDropzone={false}
              filesLimit={10}
              cancelButtonText={LOCALE.close}
              submitButtonText={LOCALE.save}
              dialogTitle={LOCALE.uploadFile}
              onSave={() => setOpenUploadDialog(false)}
              onClose={() => setOpenUploadDialog(false)}
              open={openUploadDialog}
              dropzoneText={LOCALE.dropzoneText}
              acceptedFiles={[".pdf", ".docx", ".xls", ".xlsx", ".rar", ".zip"]}
            ></DropzoneDialog>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell>
                    <strong>{LOCALE.fileName}</strong>
                  </TableCell>
                  <TableCell style={{ width: "200px", textAlign: "center" }}>
                    <strong>{LOCALE.fileSize}</strong>
                  </TableCell>
                  <TableCell style={{ width: "200px", textAlign: "center" }}>
                    <strong>{LOCALE.actions}</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(formData &&
                  formData.attachments &&
                  formData.attachments.length > 0) === false && (
                  <TableRow>
                    <TableCell colSpan={4}>
                      <Icon
                        style={{ verticalAlign: "bottom", color: "orange" }}
                      >
                        warning
                      </Icon>{" "}
                      {LOCALE.no_documents_attached}
                    </TableCell>
                  </TableRow>
                )}
                {formData &&
                  formData.attachments &&
                  formData?.attachments.map((attachment, index) => (
                    <TableRow>
                      <TableCell>
                        <FileIcon
                          size={50}
                          extension={attachment.fileExtension}
                          {...defaultStyles[attachment.fileExtension]}
                        />
                      </TableCell>
                      <TableCell>{attachment.filename}</TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        {filesize(attachment.fileSize)}
                      </TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        <a
                          target="blank"
                          href={`${
                            SETTINGS.API_URL
                          }vacancyApplications/${vacancyApplicationId}/attachments/${
                            attachment.id
                          }?access_token=${
                            AuthService.getToken().access_token
                          }`}
                        >
                          <IconButton
                            size="small"
                            color="secondary"
                            aria-label="Download"
                          >
                            <Icon>cloud_download</Icon>
                          </IconButton>
                        </a>
                        {!props.disabled && (
                          <IconButton
                            size="small"
                            color="secondary"
                            aria-label="delete"
                            onClick={() => deleteFile(attachment.id, index)}
                          >
                            <Icon>delete</Icon>
                          </IconButton>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
            <br />
            <br />
            <Button
              color="secondary"
              variant="contained"
              onClick={() => handleSubmit()}
              style={{ float: "right", marginBottom: "20px" }}
            >
              {LOCALE.submit_evaluation}
            </Button>
            <br />
            <br />
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
}
